import { storeConstants } from '@utils/constants';
import { normalizeOfferToken } from '@utils/storeDataNormalization';
import storeModuleFactory from '@helpers/storeModuleFactory';
import { apiService } from '@api';
import notificationUtils from '@/utils/notificationUtils';

const STORE_NAME = 'offerTokens';

const store = storeModuleFactory.createModuleView(
    STORE_NAME,
    {
        get: apiService.offerTokens.get,
    },
    {
        actionGetOptionsDefault: {
            refresh: false,
            offset: 0,
            limit: storeConstants.ITEMS_PER_PAGE,
        },

        mapListItemFn: normalizeOfferToken,
    },
    {
        state: {
            filters: {},
            list: [],
            totalCount: 0,
            selectedOfferToken: null,
        },

        getters: {
            filters: (state) => state.filters,
            total: (state) => state.totalCount,
            list: (state) => state.list,
            selectedOfferToken: (state) => state.selectedOfferToken,
        },

        mutations: {
            UPDATE_FILTERS(state, { filters }) {
                state.filters = filters;
            },
            setSelectedOfferToken(state, offerToken) {
                state.selectedOfferToken = offerToken;
            },
        },

        actions: {
            async updateFilters({ commit }, { filters }) {
                return commit('UPDATE_FILTERS', { filters });
            },
            setSelectedOfferToken({ commit }, offerToken) {
                commit('setSelectedOfferToken', offerToken);
            },
            async getOfferToken({ commit }, offerToken) {
                const response = await apiService.offerTokens.getOne(offerToken);
                if (response.success && response.data?.list?.length) {
                    commit('setSelectedOfferToken', normalizeOfferToken(response.data.list[0]));
                }
            },
            async createOfferToken(_, { offer }) {
                const response = await apiService.offerTokens.create(offer);
                return response;
            },
            async updateOfferToken({ dispatch }, { offer }) {
                const response = await apiService.offerTokens.update(offer.offerToken, {
                    offerTokenName: offer.offerTokenName,
                    offerTokenActive: offer.offerTokenActive,
                    priceRuleset: offer.priceRuleset,
                });
                if (!response.success) {
                    dispatch('notification/error', notificationUtils.getFromApiResponse(response), {
                        root: true,
                    });
                }
                return response;
            },
        },
    }
);

export default store;
